import React, { useState } from 'react'
import DeviceList from '../../components/device/device-list/deviceList.component'
import Layout from '../../components/layout/layout'
import DeviceView, {
  DeviceViewContext,
} from '../../components/device/device-info-view/deviceView'
import styles from '../device-management/device-management.module.css'
import ProvisionConfirmDialog from '../../components/device/device-provision/confirm-dialog'
import { DEVICE_STATUS_ENUM } from '../../services/device'

const DevicesProvision = () => {
  const [viewDevice, setViewDevice] = useState(false)
  const [deviceData, setDeviceData] = useState(false)
  const [showConfirmDialog, setShowConfirmDialog] = useState(false)

  return (
    <Layout>
      <DeviceViewContext.Provider
        value={{
          viewDevice,
          setViewDevice,
          deviceData,
          setDeviceData,
          showConfirmDialog,
          setShowConfirmDialog,
        }}
      >
        <div className={styles.container}>
          {viewDevice ? (
            <DeviceView />
          ) : (
            <DeviceList
              className={styles.list}
              status={DEVICE_STATUS_ENUM.CONFIGURED}
            />
          )}
        </div>
        <ProvisionConfirmDialog
          showConfirmDialog={showConfirmDialog}
          setShowConfirmDialog={setShowConfirmDialog}
          device={deviceData}
        />
      </DeviceViewContext.Provider>
    </Layout>
  )
}
export default DevicesProvision
